module.exports = __webpack_public_path__ + "static/media/rw.559f166d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/rw.svg
// module id = 237
// module chunks = 0